export default __webpack_public_path__ + "static/media/07.3db71e73.jpg";